var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm._m(0), _c('div', {
    staticClass: "section-title"
  }, [_vm.canAddNextMonth ? _c('div', {
    staticClass: "text-primary",
    on: {
      "click": _vm.addNextMonth
    }
  }, [_vm._v(" + pridať nasledujúci mesiac ")]) : _vm._e()]), _c('div', {
    staticClass: "date-picker-wrapper"
  }, _vm._l(_vm.monthlyData, function (month, index) {
    return _c('div', {
      key: index,
      staticClass: "diets-amounts-month-wrapper"
    }, [_c('div', {
      staticClass: "input-group"
    }, [_c('label', {
      staticClass: "field-label",
      attrs: {
        "for": 'Month-payment' + index
      }
    }, [_vm._v(" " + _vm._s(_vm.months[month.mesiac]) + " " + _vm._s(month.rok) + " ")]), _c('div', {
      staticClass: "month-wrapper"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.number",
        value: month.suma,
        expression: "month.suma",
        modifiers: {
          "number": true
        }
      }],
      staticClass: "text-input w-input",
      attrs: {
        "type": "number",
        "step": "0.01",
        "min": "0",
        "name": 'Month-payment' + index,
        "id": 'Month-payment' + index,
        "data-name": "'Month-payment' + index",
        "required": ""
      },
      domProps: {
        "value": month.suma
      },
      on: {
        "change": _vm.showEstimatedDtiToUser,
        "input": function input($event) {
          if ($event.target.composing) return;
          _vm.$set(month, "suma", _vm._n($event.target.value));
        },
        "blur": function blur($event) {
          return _vm.$forceUpdate();
        }
      }
    }), index !== 0 ? _c('div', {
      staticClass: "copy-button",
      on: {
        "click": function click($event) {
          return _vm.copy(index - 1, index, 'suma');
        }
      }
    }, [_c('span', {
      staticClass: "pop-600 bl-color copy-text pointer noselect"
    }, [_vm._v(" COPY ")])]) : _vm._e()]), index > 2 ? _c('div', {
      staticClass: "closebtn-broker-app pointer",
      on: {
        "click": function click($event) {
          return _vm.removeMonthlyIncome(index);
        }
      }
    }, [_c('img', {
      staticClass: "nav-link-icon extrasmall white",
      attrs: {
        "src": "https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/648b04f9d8e52d9524912f24_icons8-close.svg"
      }
    })]) : _vm._e()]), _c('div', {
      staticClass: "input-group"
    }, [_c('label', {
      staticClass: "field-label",
      attrs: {
        "for": 'Month-payment' + index
      }
    }, [_vm._v(" " + _vm._s(_vm.months[month.mesiac]) + " " + _vm._s(month.rok) + " ")]), _c('div', {
      staticClass: "month-wrapper"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.number",
        value: month.diety,
        expression: "month.diety",
        modifiers: {
          "number": true
        }
      }],
      staticClass: "text-input w-input",
      attrs: {
        "type": "number",
        "step": "0.01",
        "min": "0",
        "name": 'Month-payment' + index,
        "id": 'Month-payment' + index,
        "data-name": "'Month-payment' + index",
        "required": ""
      },
      domProps: {
        "value": month.diety
      },
      on: {
        "change": _vm.showEstimatedDtiToUser,
        "input": function input($event) {
          if ($event.target.composing) return;
          _vm.$set(month, "diety", _vm._n($event.target.value));
        },
        "blur": function blur($event) {
          return _vm.$forceUpdate();
        }
      }
    }), index !== 0 ? _c('div', {
      staticClass: "copy-button",
      on: {
        "click": function click($event) {
          return _vm.copy(index - 1, index, 'diety');
        }
      }
    }, [_c('span', {
      staticClass: "pop-600 bl-color copy-text pointer noselect"
    }, [_vm._v(" COPY ")])]) : _vm._e()])])]);
  }), 0), _c('div', {
    staticClass: "section-title"
  }, [_c('div', {
    staticClass: "text-primary",
    on: {
      "click": _vm.addPreviousMonth
    }
  }, [_vm._v(" + predchádzajúci mesiac ")])])]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "amounts-title text-small light blc-color"
  }, [_c('p', [_vm._v("Sumy")]), _c('p', [_vm._v("Diety")])]);

}]

export { render, staticRenderFns }